<template>
  <b-container>
    <h1>{{ $t("tracking.disapprovedReason.list") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <b-row>
      <router-link :to="getUrlCreate()">
        <b-button size="sm">{{ $t("geral.create") }}</b-button>
      </router-link>
    </b-row>

    <b-table
      ref="table"
      class="table-nowrap"
      :busy.sync="isBusy"
      :items="myProvider"
      :fields="fields"
      :filter="tableFilters"
      :filter-debounce="500"
      :per-page="tablePerPage"
      :current-page="tableCurrentPage"
    >
      <template v-slot:cell(actions)="data">
        <router-link :to="getUrlEdit(data.item)">
          <b-button size="sm" class="btn-checklist">
            {{ $t("geral.edit") }}
          </b-button>
        </router-link>
        <b-button
          v-if="isDisapprovedReasonActive(data.item)"
          size="sm"
          class="btn-checklist ml-2"
          @click="disapprovedReasonDesactive(data.item)"
          >{{ $t("geral.delete") }}</b-button
        >
        <b-button
          v-else
          size="sm"
          class="btn-checklist ml-2"
          @click="disapprovedReasonActivate(data.item)"
          >{{ $t("geral.activate") }}</b-button
        >
        <!-- <div>{{getUrlEdit(data.item)}}</div> -->
      </template>
      <template v-slot:cell(ativo)="data">
        {{ data.value ? "Sim" : "Não" }}
      </template>
    </b-table>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </b-container>
</template>
<script>
export default {
  name: "DisapprovedReasonList",
  directives: {},
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },
  props: {},
  data() {
    return {
      alert: {
        error: "",
        success: "",
      },
      isBusy: false,
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "sequenceNumber",
          filterKey: "sequenceNumber",
          label: this.$t("tracking.nonAttendanceReason.sequenceNumber"),
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "displayName",
          filterKey: "displayName",
          label: this.$t("tracking.nonAttendanceReason.displayName"),
        },
        {
          key: "active",
          filterKey: "active",
          label: "Ativo",
          sortable: true,
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      tableFilters: {
        description: "",
        sequenceNumber: "",
        active: true,
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    getUrlCreate() {
      return `/trackingShippingCompany/disapprovedReason/create/`;
    },
    isDisapprovedReasonActive(disapprovedReason) {
      if (disapprovedReason) {
        return disapprovedReason.active
      }
      return true;
    },
    getUrlEdit(disapprovedReason) {
      return `/trackingShippingCompany/disapprovedReason/edit/${disapprovedReason.id}`;
    },
    myProvider(ctx, callback) {
      this.isBusy = true;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        active: true,
      };
      this.$api
        .post("/v1/disapprovedReason/list", apiParam)
        .then((response) => {
          const items = response.data.items;
          console.log(items);
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    disapprovedReasonActivate(disapprovedReason) {
      this.$api
        .get("v1/disapprovedReason/activate/" + disapprovedReason.id.toString())
        .then((response) => {
          // console.log("entrou");
          disapprovedReason.active = true;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    disapprovedReasonDesactive(disapprovedReason) {
      this.$api
        .get(
          "v1/disapprovedReason/Deactivate/" + disapprovedReason.id.toString()
        )
        .then((response) => {
          // console.log("entrou");
          disapprovedReason.active = false;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log(error);
          console.log(`error.response: ${error.response}`);
          console.log(error.response);

          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
  },

  watch: {
    model() {
      this.$forceUpdate();
    },
  },
};
</script>